const ROOT = "/sub-area-management";

const subAreaManagementPaths = {
  root: ROOT,
  AddSubArea: `${ROOT}/add-sub-area`,
};

export default subAreaManagementPaths;
